import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  openWorlds: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  worldDetail: { data: null, loading: false },
  slotDetail: { data: null, loading: false },
  zones: { data: [], loading: false },
  triggers: { data: [], loading: false },
  confirm: { title: '', content: '', visible: false, loading: false },
  searchParams: null,
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
